import styled from 'styled-components'
import { PaddingContainer } from 'components/common/common_styles'
import { sizeMobile } from 'components/globalStyles'

export const MainContainer = styled(PaddingContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Illustration = styled.img`
  align-self: flex-end;
  max-width: 500px;

  @media (max-width: ${sizeMobile}) {
    padding-top: 80px;
    align-self: center;
    max-width: 90%;
  }
`
